  // // Function to collapse all tabs on mobile screens by unchecking radio buttons
  // // and ensure the first tab is checked on larger screens
  // function adjustTabsBasedOnScreenSize() {
  //   const radios = document.querySelectorAll('.tab-radio');
  //   if (window.innerWidth < 720) {
  //     radios.forEach(radio => {
  //       radio.checked = false; // Uncheck the radio to collapse tabs
  //     });
  //   } else {
  //     radios[0].checked = true; // Ensure the first tab radio is checked on larger screens to expand tabs
  //   }
  // }
  // // Debounce function to limit how often a function is executed during resize events
  // function debounce(func, wait, immediate) {
  //   var timeout;
  //   return function() {
  //     var context = this, args = arguments;
  //     var later = function() {
  //       timeout = null;
  //       if (!immediate) func.apply(context, args);
  //     };
  //     var callNow = immediate && !timeout;
  //     clearTimeout(timeout);
  //     timeout = setTimeout(later, wait);
  //     if (callNow) func.apply(context, args);
  //   };
  // }
  // // Adjust tabs based on screen size on initial load and on resize
  // adjustTabsBasedOnScreenSize();
  // window.addEventListener('resize', debounce(adjustTabsBasedOnScreenSize, 250)); // Adjust the 250 ms delay based on performance needs



// Function to adjust tabs based on screen size, maintaining state unless crossing the 720px threshold
  function adjustTabsBasedOnScreenSize() {
    const radios = document.querySelectorAll('.tab-radio');
    const currentlyCheckedIndex = Array.from(radios).findIndex(radio => radio.checked);
    const isMobileView = window.innerWidth < 720;

    if (isMobileView && (currentlyCheckedIndex !== -1 || currentlyCheckedIndex >= radios.length)) {
      radios.forEach(radio => radio.checked = false); // Uncheck all radios in mobile view
    } else if (!isMobileView && (currentlyCheckedIndex === -1 || currentlyCheckedIndex < 0)) {
      radios[0].checked = true; // Ensure the first tab is checked in desktop view
    }
  }

  // Debounce function to limit how often a function is executed during resize events
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // Variable to store the last window width to detect crossing of the threshold
  let lastWidth = window.innerWidth;

  // Enhanced function to handle resize with threshold crossing detection
  function handleResize() {
    const currentWidth = window.innerWidth;
    const crossedThreshold = (lastWidth >= 720 && currentWidth < 720) || (lastWidth < 720 && currentWidth >= 720);
    if (crossedThreshold) {
      adjustTabsBasedOnScreenSize();
    }
    lastWidth = currentWidth; // Update lastWidth for the next resize event
  }

  // Adjust tabs based on screen size on initial load and on resize with threshold detection
  adjustTabsBasedOnScreenSize();
  window.addEventListener('resize', debounce(handleResize, 250)); // Adjust the 250 ms delay based on performance needs